import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { messages } from '../messages';
import { noop } from 'ui-components/default-props/noop';

export const BillToParty = {
  id: 'bill-to-party',
  displayName: <FormattedMessage {...messages.billToPartyIndicator} />,
  type: OptionFormTypes.TYPE_CONTAINS,
  filterValue: 'BillToParty',
  render: noop,
};
